<template>
    <nav
      :class="{
        'header-menu-simplified': true,
        'header-menu-simplified--active': menuActiveFlag
      }"
    >
      <div
        :class="{
          'header-menu__content': true,
          'header-menu__content--active': menuActiveFlag
        }"
      >
        <div class='hamburgermenu-blocks'>
          <slot />
        </div>
      </div>
    </nav>
</template>
  
<script>
  
  export default {
  
    props: {
      menuActiveFlag: {
        type: Boolean,
        default: false
      },
      outlink: {
        type: Array,
        default: null
      }
    },
    watch: {
      menuActiveFlag: function(value) {
        if (value) document.getElementsByTagName("body")[0].style.overflow = "hidden";
        else document.getElementsByTagName("body")[0].style.overflow = "auto";
      }
    }
  };
</script>
<style lang="scss" scoped>
  
  .header-menu-simplified {
    position: absolute;
    visibility: hidden;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: flex-end;
    opacity: 0;
    transition: 0.333s ease-in-out;
    @include pad {
      background-color: rgba(#000000, 0.6);
      @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
        backdrop-filter: blur(8px);
        background-color: rgba(#000000, 0.6);
      }
    }
    @include pc {
      background-color: rgba(#000000, 0.6);
      @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
        backdrop-filter: blur(8px);
        background-color: rgba(#000000, 0.6);
      }
    }
  
    &.header-menu-simplified--active {
      visibility: visible;
      pointer-events: auto;
      opacity: 1;
      z-index: 5004;
    }
  
    .header-menu__content {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #1D1C1B;
      transform: translateX(100%);
      transition: 0.666s ease-out;
      padding: 0 17px;
      padding-top: 76px;
      overflow: scroll;

      &.header-menu__content--active {
        opacity: 1;
        pointer-events: auto;
        transform: translateX(0);
        @include pad {
          transform: translateX(0);
        }
        @include pc {
          transform: translateX(0);
        }
      }
      .hamburgermenu-blocks {
        padding-bottom: 70px;
        @media screen and (min-width: 768px) {
          padding-left: 101px;
        }
        @media screen and (min-width: 1280px) {
          padding-left: 460.5px;
        }
        .hamburgermenu-block {
          padding: 40px 0 13px 0;
          border-bottom: 1px solid rgba(139, 139, 139, 0.15);
          @media screen and (min-width: 1280px) {
            &:first-child {
              padding-top: 15px;
            }
          }
          a {
            text-decoration: none;
            font-weight: 700;
            font-size: 20px; 
            line-height: 30px;
            font-family: 'Noto Serif TC';
            opacity: 0.5;
            color: #E1E1E1;
            text-align: justify;
            cursor: pointer;
            @include clean-tap;
      
            @include pad {
              font-size: 24px; 
              line-height: 34px;
            }
            @include pc {
              font-size: 24px; 
              line-height: 34px; 
              @media (hover: hover) {
                &:hover {
                  opacity: 1;
                }
              }
            }
      
            &.active {
              opacity: 1;
              border-bottom: solid 1px #A08E33;
              padding-bottom:15px;
              cursor: initial;
            }
          }
        }
      }
    }
  }
  </style>